import * as SpecialOffersConstants from './constants';

export function enterCodeRedemptionFlow({ code, isOfferPath }) {
  return {
    type: SpecialOffersConstants.Actions.ENTER_CODE_REDEMPTION_FLOW,
    data: {
      code,
      isOfferPath,
    },
  };
}

// null means don't change data, any other value, falsy or not, will overwrite current value
export function updateSpecialOfferRedemptionState({
  specialOfferCode = null,
  specialOfferStatus = null,
}) {
  return {
    type: SpecialOffersConstants.Actions.UPDATE_REDEMPTION_STATE,
    specialOfferCode,
    specialOfferStatus,
  };
}

export function resetSpecialOffer({
  shouldResetCampaignCopy = true,
  shouldResetError = true,
} = {}) {
  return {
    type: SpecialOffersConstants.Actions.RESET_SPECIAL_OFFER,
    data: {
      shouldResetCampaignCopy,
      shouldResetError,
    },
  };
}
